import { Pipe, PipeTransform } from '@angular/core';
import { TaskTypeValueIntGroupingEnum } from '@core/enums/task-type-key.enum';
import { DictionaryModel } from '@core/models/dictionary.model';

@Pipe({
  name: 'taskTypeColor',
  standalone: true,
  pure: true
})
export class TaskTypeColorPipe implements PipeTransform {
  transform(value: DictionaryModel): string {
    return (!value || value.ValueInt === TaskTypeValueIntGroupingEnum.UNLOADING)
      ? 'blue'
      : 'magenta'
  }
}